import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export type UserType = 'reviewer' | 'advertiser';

interface UserTypeContextType {
  currentType: UserType;
  setCurrentType: (type: UserType) => void;
  switchType: () => void;
}

const UserTypeContext = createContext<UserTypeContextType | undefined>(undefined);

export const UserTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentType, setCurrentType] = useState<UserType>('reviewer');
  const navigate = useNavigate();

  const switchType = useCallback(() => {
    const newType = currentType === 'reviewer' ? 'advertiser' : 'reviewer';
    setCurrentType(newType);
    // 상태 변경 후 URL 변경
    navigate(`/mypage/${newType}`, { replace: true });
  }, [currentType, navigate]);

  return (
    <UserTypeContext.Provider value={{ currentType, setCurrentType, switchType }}>
      {children}
    </UserTypeContext.Provider>
  );
};

export const useUserType = () => {
  const context = useContext(UserTypeContext);
  if (context === undefined) {
    throw new Error('useUserType must be used within a UserTypeProvider');
  }
  return context;
};

export default UserTypeContext; 